var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImporticonsmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5861 9.6731H11.2294L18.9035 1.99535C19.152 1.74684 19.152 1.34255 18.9035 1.09404C18.7811 0.971645 18.6179 0.908591 18.4547 0.908591C18.2915 0.908591 18.1283 0.971645 18.0059 1.09404L10.3281 8.7718V5.4151C10.3281 5.06274 10.0425 4.77714 9.69388 4.77714C9.34152 4.77714 9.05592 5.06274 9.05592 5.4151V10.3074C9.05592 10.6597 9.34152 10.9453 9.69388 10.9453H14.5861C14.9385 10.9453 15.2241 10.6597 15.2241 10.3074C15.2204 9.9587 14.9385 9.6731 14.5861 9.6731Z",
    fill: "#FF6019",
    stroke: "#FF6019",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72483 19.092H15.2697C17.3764 19.092 19.0863 17.3784 19.0863 15.2753V10.3089C19.0863 9.95656 18.8007 9.67467 18.4484 9.67467C18.096 9.67467 17.8141 9.96027 17.8141 10.3089V15.2716C17.8141 16.6737 16.6717 17.8161 15.2697 17.8161H4.72483C3.3228 17.8161 2.18041 16.6737 2.18041 15.2716V6.89658V4.73049C2.18041 3.32846 3.3228 2.18607 4.72483 2.18607H9.64675C9.99911 2.18607 10.281 1.90048 10.281 1.54811C10.281 1.19575 9.9954 0.910156 9.64675 0.910156H4.72483C2.61808 0.910156 0.908203 2.62374 0.908203 4.72678V6.89287V15.2716C0.908203 17.3784 2.62179 19.092 4.72483 19.092Z",
    fill: "#FF6019",
    stroke: "#FF6019",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImporticonsmall);
export default __webpack_public_path__ + "static/media/importiconsmall.851f4501.svg";
export { ForwardRef as ReactComponent };